import React, { ReactElement, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Responsive, ResponsiveProps } from 'react-grid-layout';
import sizeMe from 'react-sizeme';
import { colors } from '@dexma/ui-components';
import { GridLayouts } from 'adapter/in/dashboards/components/generic/ReactGrid';

const sizeMeHOC = sizeMe({
    monitorWidth: true,
    refreshRate: 300,
});

export type ResponsiveReactGridLayoutProps = ResponsiveProps & {
    containerWidth: number;
    layouts: GridLayouts;
    rowHeight: number;
};

const ResponsiveReactGridLayout = (props: ResponsiveReactGridLayoutProps): ReactElement => {
    const { containerWidth, rowHeight, margin, layouts, ...passProps } = props;
    const [animated, setAnimated] = useState(false);

    useEffect(() => setAnimated(true), []);

    return (
        <div>
            <StyledResponsiveReactGridLayout
                className={animated ? 'animated' : 'none'}
                width={containerWidth}
                margin={margin}
                rowHeight={rowHeight}
                layouts={layouts}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...passProps}
            />
        </div>
    );
};

const StyledResponsiveReactGridLayout = styled(Responsive)`
    .react-grid-item.cssTransforms {
        transition-property: none;
    }

    .animated .react-grid-item.cssTransforms {
        transition-property: transform;
    }

    position: relative;

    .react-grid-item.react-grid-placeholder {
        background-color: ${colors.gray500};
        border-radius: 8px;
    }

    .react-grid-item > .react-resizable-handle::after {
        right: 10px;
        bottom: 10px;
        width: 10px;
        height: 10px;
        border-right: 2px solid ${colors.gray500};
        border-bottom: 2px solid ${colors.gray500};
        z-index: 100000;
    }
`;

export default sizeMeHOC(ResponsiveReactGridLayout);
